import React from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import styles from './styles.sass';

// Bootstrap grid override that creates a responsive grid (page content container)
// with a minumum width for DESKTOPS (set in variables.sass)
// i.e. will not be responsive on mobile screens

const DesktopGrid = ({ children, className, fillHeight = true }) => (
  <Grid
    bsClass={`
      container
      ${styles.container} 
      ${fillHeight ? styles.containerFillHeight : ''}
      ${className || ''}
    `}
  >
    {children}
  </Grid>
);

export default DesktopGrid;
